import { Box, Skeleton, Stack } from '@mui/material';
import ErrorPage from 'views/pages/maintenance/ErrorPage';
import GeneralTable from './Table/GeneralTable';
import useForecastGeneralData from '../../Queries/forecastGeneralQuery';
import Toolbar from './Toolbar/Toolbar';

export default function GeneralView() {
	const forecastGeneralQuery = useForecastGeneralData();

	if (forecastGeneralQuery.status === 'pending') {
		return <Skeletons />;
	}

	if (forecastGeneralQuery.status === 'error') {
		return <ErrorPage />;
	}

	return (
		<Stack spacing="12px" sx={{ pt: '12px' }}>
			<Toolbar count={forecastGeneralQuery?.data?.count} />

			<Box>
				<GeneralTable
					data={forecastGeneralQuery?.data?.items}
					count={forecastGeneralQuery?.data?.count}
					loading={
						forecastGeneralQuery.status === 'pending' ||
						forecastGeneralQuery.fetchStatus === 'fetching'
					}
				/>
			</Box>
		</Stack>
	);
}

function Skeletons() {
	return (
		<Stack spacing={4}>
			<Stack
				spacing={4}
				direction="row"
				sx={{
					overflowX: 'auto',
				}}
			>
				<Skeleton
					variant="rectangular"
					width={150}
					height={40}
					sx={{
						borderRadius: '5px',
					}}
				/>
				<Skeleton
					variant="rectangular"
					width={150}
					height={40}
					sx={{
						borderRadius: '5px',
					}}
				/>
				<Skeleton
					variant="rectangular"
					width={150}
					height={40}
					sx={{
						borderRadius: '5px',
					}}
				/>
				<Skeleton
					variant="rectangular"
					width={150}
					height={40}
					sx={{
						borderRadius: '5px',
					}}
				/>
			</Stack>
			<Skeleton
				variant="rectangular"
				width="100%"
				height={'calc(100vh - 312px)'}
				sx={{
					borderRadius: '5px',
				}}
			/>
		</Stack>
	);
}
